/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Anzahlmentees1Inputs */

const en__field_anzahlmentees1 = /** @type {(inputs: _Field_Anzahlmentees1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number of Pupils`)
};

const de__field_anzahlmentees1 = /** @type {(inputs: _Field_Anzahlmentees1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl Schüler:innen`)
};

/**
* | output |
* | --- |
* | "Number of Pupils" |
*
* @param {_Field_Anzahlmentees1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_anzahlmentees1 = /** @type {((inputs?: _Field_Anzahlmentees1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Anzahlmentees1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_anzahlmentees1(inputs)
	return de__field_anzahlmentees1(inputs)
});
export { _field_anzahlmentees1 as "_field_anzahlMentees" }